/* global grecaptcha */
/**  grecaptcha is assigned to the global window variable by the script
 * in the loadRecaptcha function
 */
import config from '@epi-config';
const scriptId = 'reCaptchaScript';

declare global {
  interface Window {
    grecaptcha: {
      ready: (callback: () => void) => void;
      execute: (key: string, options: { action: string }) => Promise<string>;
    };
  }
}

const getScript = () => document.getElementById(scriptId);

const isScriptLoaded = () =>
  getScript() && getScript()?.getElementsByClassName('isLoaded').length === 1;

const loadRecaptcha = (key: string, callback?: () => void) => {
  const existingScript = getScript();

  if (!existingScript) {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${key}`;
    script.id = scriptId;
    document.body.appendChild(script);

    script.onload = () => {
      getScript()?.classList.add('isLoaded');
      if (callback) {
        callback();
      }
    };
  }

  if (existingScript && callback) callback();
};

export const loadRecaptchaScript = (key: string): Promise<void> =>
  new Promise(resolve => {
    if (isScriptLoaded()) {
      resolve();
    }
    loadRecaptcha(key, resolve);
  });

export const getRecaptchaToken = (
  key: string,
  action: string
): Promise<string> => {
  if (config.disableReCaptcha) {
    return Promise.resolve('');
  }

  return new Promise(resolve => {
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(`${key}`, {
          action
        })
        .then(resolve);
    });
  });
};
